import LegalPageLayout from "../components/LegalPageLayout";

function TermsOfService() {

    return (

        <LegalPageLayout title="Terms of Service">

            <p className="legal-effective-date">Last updated: 2026</p>

            <h2>Copyright &amp; Ownership</h2>
            <p>
                &copy; 2026 Kinetiq Robotics Private Limited (KRPL). All rights reserved. All
                software, proprietary portal interfaces, live telemetry visualization tools,
                algorithmic data models, and platform content are the exclusive intellectual
                property of Kinetiq Robotics Private Limited. Unauthorized duplication, extraction,
                reverse engineering, or distribution of this portal's assets is strictly prohibited
                and subject to legal action.
            </p>

            <p>
                By accessing and utilizing the KRPL Customer Portal, you agree to comply with these
                terms and all applicable industrial automation laws. This platform is provisioned
                solely for the management, monitoring, and calibration of authorized Kinetiq
                Robotics Private Limited hardware.
            </p>

            <h2>Credential Security</h2>
            <p>
                User accounts are non-transferable. Your organization is entirely responsible for
                maintaining the strict confidentiality of corporate login credentials and for all
                actions taken under those accounts.
            </p>

            <h2>Operational Safety &amp; Remote Commands</h2>
            <p>
                Remote firmware deployments, configuration modifications, and operational overrides
                executed via this portal must be initiated exclusively by certified personnel in
                strict adherence to KRPL safety manuals and factory floor guidelines.
            </p>

            <h2>Liability Limitation</h2>
            <p>
                KRPL provides this portal as an operational optimization tool. KRPL shall not be
                held liable for production downtime, hardware damage, or safety incidents resulting
                from unauthorized portal access, credential sharing, network disruptions, or
                negligent remote commands executed by the user.
            </p>

        </LegalPageLayout>

    );

}

export default TermsOfService;
